import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface TextMiningProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_files: {
    [flowConfig.INPUT_DATA]: string;
    [flowConfig.WORD_MAPPER_DATA]?: string;
  };
  meta_data: {
    [flowConfig.TEXT_COLUMNS_KEY]: string[];
    [flowConfig.WORD_MAPPER_KEY_NAME]: string;
    [flowConfig.WORD_MAPPER_VALUE_NAME]: string;
  };
}

export const projectIsTextMining = (
  project: Project
): project is TextMiningProject => project.flow === flowConfig.FLOW_NAME;
